import { omit } from 'lodash-es';

export const sanitizeInputProps = (props: Record<string, unknown>) =>
  omit(props, [
    'autoGrow',
    'MakeComponent',
    'hideErrors',
    'hideTitle',
    'iconPosition',
    'isClearable',
    'isHidden',
    'isSearchable',
    'item',
    'keyFormValues',
    'ownKey',
    'parentKey',
    'parentSchema',
    'placeholderText',
    'showQuestionId',
    'showQuestionKey',
    'startCollapsed',
    'textTransform',
    'toggleDependsOn',
    'validationErrors',
  ]);
